export default "__VITE_ASSET__CfngBNtN__"